import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Community from "../pages/community/page";
import PostDetail from "../pages/post/page";
import Topics from "../pages/topics/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/community",
    element: <Community />,
  },
  {
    path: "/post/:id",
    element: <PostDetail />,
  },
  {
    path: "/topics",
    element: <Topics />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;